const abTestEnabled = process.env.GATSBY_AB_TEST === 'true';

export default abTestEnabled;
